import { Methods } from '../../api/methods.js';
import type { ParsedArgs } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { request, requireConfirmation } from './common.js';

export async function updateCommand(args: ParsedArgs): Promise<CommandResult> {
  const action = args.positionals[1] ?? 'check';
  const method =
    action === 'check' ? Methods.UpdateCheck : action === 'apply' ? Methods.UpdateApply : undefined;
  if (!method) throw new CliError(`Unknown update action "${action}"`, ExitCode.Usage);
  if (action === 'apply') requireConfirmation(args, 'Applying a Core update requires confirmation');
  return request(args, method);
}
